import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const ResetPasswordRedirect = () => {
  const { token } = useParams();

  useEffect(() => {
    // Create the deep link URL - matches your React Native config
    const deepLink = `freshsweeper://reset-password/${token}`;

    console.log('🔗 Redirecting to app:', deepLink);
    
    // Redirect immediately to the app
    window.location.href = deepLink;

    // Optional: If you want to handle the case where app isn't installed,
    // you could redirect to a download page after a delay
    const fallbackTimer = setTimeout(() => {
      if (document.visibilityState === 'visible') {
        // User is still on this page - app likely not installed
        console.log('📱 App not installed');
        // Optionally redirect to app store or show a message
        // window.location.href = 'https://apps.apple.com/app-id'; // iOS
        // window.location.href = 'https://play.google.com/store/apps/details?id=com.yourapp'; // Android
      }
    }, 2000);

    return () => clearTimeout(fallbackTimer);
  }, [token]);

  return (
    <div style={styles.container}>
      <h2>🔐 Reset Your Password</h2>
      <p>Redirecting you to the FreshSweeper app...</p>
      <div style={styles.spinner}>⏳</div>
    </div>
  );
};

const styles = {
  container: {
    padding: '40px 20px',
    textAlign: 'center',
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    maxWidth: '600px',
    margin: '0 auto',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinner: {
    fontSize: '40px',
    marginTop: '20px',
  }
};

export default ResetPasswordRedirect;